/**
 * EventOrganizer Entity Schemas
 *
 * A reusable, school-scoped organizer (e.g. "Westminster Athletics") that brands
 * one or more event collections with a logo + name. Admin-created per school;
 * `name` is unique within a school. Designed so events can reference the same
 * entity later (not wired this release).
 */

import { z } from 'zod'

/**
 * Admin-facing organizer DTO. `id` is the CUID `publicId`. `collectionCount` is
 * the blast-radius figure surfaced on edit/delete (how many collections use it).
 */
export const TicketedEventOrganizerSchema = z.object({
  id: z.string(),
  name: z.string(),
  logoUrl: z.string().nullable(),
  collectionCount: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string().nullable()
})
export type TicketedEventOrganizer = z.infer<typeof TicketedEventOrganizerSchema>
